export default class MobileNav {
  constructor() {
    this.state = {
      drawerMenuOpen: false,
      discsMenuOpen: false,
      dealersMenuOpen: false,
      focus: false
    };
    this.selectors = {
      hamburger: $('.mobileNav__hamburger > svg'),
      mobileNav: {
        html: $('html, body'),
        topBar: $('.mobileNav'),
        sideBar: $('.main-navigation'),
        viewPortContent: $('.viewport-content'),
        pageContent: $('.page-content'),
        overLay: $('.nav-overlay'),
        hamburgerTop: $('#hamburger-top'),
        hamburgerMiddle: $('#hamburger-middle'),
        hamburgerBottom: $('#hamburger-bottom'),
        wrapperNav: $('.wrapper-nav')
      },
      discsNav: $('.mobileNav__discs'),
      dealersNav: $('.mobileNav__dealers')
    };
    this.watch();
  }
  watch() {
    this.selectors.hamburger.on('click', () => { this.setState('drawerMenuOpen'); });
    this.selectors.discsNav.on('click', () => { this.setState('discsMenuOpen'); });
    this.selectors.dealersNav.on('click', () => { this.setState('dealersMenuOpen'); });
    this.selectors.mobileNav.overLay.on('click', () => { this.setState('focus');} );
  }
  addAccordion() {

  }
  setState(target) {
    let targetState = this.state[target];
    let stateBoolean;
    if (targetState == true) {
      stateBoolean = false;
    } else {
      stateBoolean = true;
    }
    Object.keys(this.state).forEach(v => this.state[v] = false);
    this.state[target] = stateBoolean;
    if (target !== 'focus' && this.state.dealersMenuOpen || this.state.discsMenuOpen || this.state.drawerMenuOpen) {
      this.state.focus = true;
    } else {
      this.state.focus = false;
    }
    this.renderState();
  }
  renderState() {
    const {topBar, sideBar, viewPortContent, hamburgerTop, hamburgerBottom, hamburgerMiddle, html, overLay, pageContent, wrapperNav} = this.selectors.mobileNav;
    const {discsNav, dealersNav} = this.selectors;
    const {drawerMenuOpen, discsMenuOpen, dealersMenuOpen, focus} = this.state;

    topBar.toggleClass('close', !drawerMenuOpen);
    topBar.toggleClass('open', drawerMenuOpen);
    sideBar.toggleClass('close', !drawerMenuOpen);
    sideBar.toggleClass('open', drawerMenuOpen);
    viewPortContent.toggleClass('close', !drawerMenuOpen);
    viewPortContent.toggleClass('open', drawerMenuOpen);
    hamburgerTop.toggleClass('close', !drawerMenuOpen);
    hamburgerTop.toggleClass('open', drawerMenuOpen);
    hamburgerMiddle.toggleClass('close', !drawerMenuOpen);
    hamburgerMiddle.toggleClass('open', drawerMenuOpen);
    hamburgerBottom.toggleClass('close', !drawerMenuOpen);
    hamburgerBottom.toggleClass('open', drawerMenuOpen);
    wrapperNav.toggleClass('close', !drawerMenuOpen);
    wrapperNav.toggleClass('open', drawerMenuOpen);

    discsNav.toggleClass('close', !discsMenuOpen);
    discsNav.toggleClass('open', discsMenuOpen);

    dealersNav.toggleClass('close', !dealersMenuOpen);
    dealersNav.toggleClass('open', dealersMenuOpen);

    html.toggleClass('close', !focus);
    html.toggleClass('open', focus);
    overLay.toggleClass('close', !focus);
    overLay.toggleClass('open', focus);
    pageContent.toggleClass('close', !focus);
    pageContent.toggleClass('open', focus);

  }
}
